<template>
  <div class="yunxiao parent member">
    <Top :userInfo="memberUserInfos" />
    <!-- 会员权益 -->
    <section class="p16-lr bg-white" style="margin-top: cacl(var(--gap) *-11)" v-if="homeData.allEntitlementList.length > 0">
        <div class="g-border-bottom g-flex-v-center h-46">
            <span>
                <span class="title">会员权益</span>
                <span class="more ml5" v-if="homeData.ownEntitleNum || homeData.allEntitleNum" >({{ homeData.ownEntitleNum }}/{{ homeData.allEntitleNum }})</span>
            </span>
            <span class="more g-flex-center" @click="toUserRights">
                <span>更多权益</span>
                <van-icon name="arrow" class="arrow-icon" ></van-icon>
            </span>
        </div>
        <UserRights 
          :datas="homeData.entitlementList.length > 0 ? homeData.entitlementList : homeData.allEntitlementList"
          :isOwn="homeData.entitlementList.length > 0">
        </UserRights>
    </section>
    <!-- 做任务，赚积分 -->
    <section class="p16-lr bg-white mt12">
        <div class="g-border-bottom g-flex-v-center h-46">
            <span class="title">做任务，赚积分</span>
            <span class="more g-flex-center" style="color: #2eaaf7;" @click="$router.push('/member-rule')">
                <span>积分规则</span>
                <van-icon name="arrow"></van-icon>
            </span>
        </div>
        <ul v-if="homeData.taskList.length > 0">
            <li 
              class="task-item" 
              :class="{ 'g-border-bottom': i !== homeData.taskList.length }" 
              v-for="i in homeData.taskList"
              :key="i.id">
                <div class="g-flex-center">
                    <!-- <div class="task-icon g-flex-vh-center" :style="{ background: i.bg }">
                        <svg-icon :name="i.icon" :width="20" :height="20"></svg-icon>
                    </div> -->
                    <div class="task-icon g-flex-vh-center">
                        <VanImage width="34" height="34" :src="i.img" />
                    </div>
                    <div>
                        <p class="g-fs14">{{ i.taskName }}</p>
                        <p class="g-fs12 task-count">
                          <svg
                            class="vxm-icon"
                            aria-hidden="true"
                            font-size="14"
                          >
                            <use :xlink:href="'#vxm-icon-a-19'"></use>
                          </svg>
                          <span class="a">积分</span>
                          <span class="b">{{ i.receivePoint > 0 ? `+${i.receivePoint}` : i.receivePoint }}</span>
                        </p>
                    </div>
                </div>
                <button class="pro-button" :class="{ gray: i.marker }" @click="toSign(i)">{{ i.marker ? i.doneName : i.doName }}</button>
            </li>
        </ul>
        <van-empty v-else image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png" description="暂无任务" image-size="90"  />
    </section>


    <section class="p16-lr bg-white mt12" v-if="pointExchange">
      <div class="g-flex-v-center h-46">
            <span class="title">积分商城</span>
            <span class="more g-flex-center" style="color: #2eaaf7;" @click="$router.push('/home/1?point=1')">
                <span>去看看</span>
                <van-icon name="arrow"></van-icon>
            </span>
        </div>
    </section>
    <!-- 会员活动 -->
    <section class="p16-lr bg-white mt12">
        <div class="g-border-bottom g-flex-v-center h-46">
            <span class="title">会员活动</span>
            <span class="more g-flex-center" v-if="list.length" @click="$router.push('/member-activities')">
                <span>更多活动</span>
                <van-icon name="arrow" class="arrow-icon" ></van-icon>
            </span>
        </div>
          <div class="ph6 list" v-if="list.length" @click="toDetail(list[0].id)">
            <div class="g-flex">
                <van-image 
                    width="40" 
                    height="40" 
                    :src="`https://cdn01.xiaogj.com/uploads/x3/assets/m/img/parent/member/act${list[0].type}.png`" />
                <div class="ml">
                    <p class="name">{{ list[0].name }}</p>
                    <div v-if="list[0].timeType === 1" class="date">
                        <p>
                            <span>开始时间:</span>
                            <span>{{ list[0].startDate }}</span>
                        </p>
                        <p>
                            <span>结束时间:</span>
                            <span>{{ list[0].endDate }}</span>
                        </p>
                    </div>
                    <div v-if="list[0].timeType === 0" class="date">
                        <p>
                            <span>开始时间:</span>
                            <span>每月{{ list[0].startDay }}日</span>
                        </p>
                        <p>
                            <span>结束时间:</span>
                            <span>每月{{ list[0].endDay }}日</span>
                        </p>
                    </div>
                </div>
            </div>
            <div :style="{ color: colors[list[0].status] }">{{ statusNames[list[0].status] }}</div>
        </div>
        <van-empty 
          v-else
          style="padding:0;"
          image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png" 
          description="暂无活动" 
          image-size="90" />
    </section>
  </div>
</template>

<script>
import Top from "./coms/top.vue";
import UserRights from "./coms/user-rights.vue";
export default {
  name: 'memberIndex',
  components: {
    Top,
    UserRights,
  },
  computed: {
    // 积分兑换
    pointExchange(){
      return this.promotion && this.promotion.find(item=> item.promotionType === 'POINT');
    }
  },
  data () {
    return {
      pageTitle: '会员中心',
      memberUserInfos: {},
      homeData: {
        ownEntitleNum: 0,
        allEntitleNum: 0,
        entitlementList: [],
        allEntitlementList: [],
        taskList: [],
      },
      list: [],
      statusNames: ['未开始', '进行中', '已结束'],
      colors: ['#FFB900', '#FE6760', '#969799'],
      promotion: [],
    }
  },
  methods: {
    getUserInfos() {
      this.$store.dispatch('queryMemberGetMemberInfo', this.$vxRoute.query.sId)
        .then(data=> {
          this.memberUserInfos = data;
          this.$toast.clear()
        })
        .catch(err=>{
          console.log(err)
        })
      this.queryHomeData(this.$vxRoute.query.sId);
      this.getYouhui();
    },
    // 去权益页面
    toUserRights () {
      this.$router.push('/member-rights')
    },
    getPageMemberActivity () {
      this.$api.pageMemberActivity({studentId: this.$vxRoute.query.sId, page:0,pageSize: 1})
        .then(res => {
          this.list = (res.data && res.data.records) || []
        })
    },
    queryHomeData  (sId)  {
      const handleHomeData = data => {
          if (!data) {
              return
          }
          this.homeData.allEntitleNum = data.allEntitleNum || 0
          this.homeData.ownEntitleNum = data.ownEntitleNum || 0
          this.homeData.taskList =
              data.taskList && data.taskList.map(item => {
                  switch (item.taskType) {
                      case 1:
                          // item.icon = 'iconqiandao'
                          // item.bg = '#2EAAF7'
                          item.img = 'https://cdn01.xiaogj.com/uploads/x3/assets/m/img/parent/member/sign.png'
                          item.doName = '签到'
                          item.doneName = '已签到'
                          break
                      case 2:
                          // item.icon = 'iconhuiyuan'
                          // item.bg = '#FF7437'
                          item.img = 'https://cdn01.xiaogj.com/uploads/x3/assets/m/img/parent/member/info.png'
                          item.doName = '去完善'
                          item.doneName = '已完成'
                          break
                      case 15: 
                          item.img = 'https://cdn01.xiaogj.com/uploads/x3/assets/m/img/parent/member/info.png'
                          item.doName = '已完成'
                          item.doneName = '已完成'
                          break;
                  }
                  return item
              }) || []
          this.homeData.allEntitlementList = data.allEntitlementList || []
          this.homeData.entitlementList = data.entitlementList || []
      }
      this.$api.memberQueryH5HomePage({ studentId: sId }).then(res => {
          handleHomeData(res.data)
      })
    },
    toSign (item) {
      if (item.marker) {
          return
      }
      const taskId = item.taskId
      const taskType = item.taskType
      // 每日签到
      if (taskType === 1) {
          this.$api.memberSignInH5({ taskId, memberId: this.memberUserInfos.id }).then(res => {
              if (res.code === 200) {
                this.$toast('签到成功');
                this.updateAllInfos();
              }
          })
      }
      // 完善会员信息
      if (taskType === 2) {
          this.$router.push('/member-usermodify')
      }
    },
    updateAllInfos () {
      this.queryHomeData(this.$vxRoute.query.sId);
      this.getUserInfos();
    },
    toDetail (id){
      const { companyId, companyName } = this.memberUserInfos
      this.$router.push(`/member-activity-detail?id=${id}&companyId=${companyId}&companyName=${companyName}`)
    },
    async getYouhui(){
      const res = await this.$api.promotionValidPage({
        studentId: this.memberUserInfos.id
      });
      this.promotion = res.data;
    },
  },
  created () {
    this.showLoading() 
    this.getUserInfos()
    this.getPageMemberActivity()
    this.$onBus('updateInfosSuccess', this.updateAllInfos)
  },
}
</script>

<style lang="scss" scoped>
.p16-lr {
    padding: 0 calc(var(--gap) * 16);
}
.ph6 {
    padding: 6px 0;
}
.list {
    display: flex;
    justify-content: space-between;
}
.g-flex {
    display: flex;
}
.g-flex-center {
    display: flex;
    align-items: center;
}
.bg-white {
    background-color: #fff;
}
.h-46 {
    height: calc(var(--gap) * 46);
}
.g-flex-v-center {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.mt12 {
    margin-top: calc(var(--gap) * 12)
}
.ml5 {
    margin-left: calc(var(--gap) * 5);
}
.more {
    font-size: 14px;
    color: #969799;
}
.title {
  font-size:var(--fs-ex1);
  font-weight: 500;
}
p{
  margin: 0;
}
.g-border-bottom{
  position: relative;
  &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 1px;
      background-image: linear-gradient(0deg, #e5e5e5 50%, transparent 50%);
  }
}
.pro-button.gray {
    background-color: #ccc;
}
.task-item {
    height: calc(var(--gap) * 72);
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.task-icon {
    width: calc(var(--w) * 34);
    height: calc(var(--w) * 34);
    margin-right: calc(var(--gap) * 10);
    border-radius: 50%;
}
.pro-button {
    width: calc(var(--w) * 74);
    height: calc(var(--gap) * 30);
    background-color: #2eaaf7;
    border-radius: calc(var(--radius-base) * 3.75);
    border: none;
    font-size:var(--fs-sm);
    line-height:var(--lh-sm);
    color: var(--white);
    outline: none;
}
.task-count {
    margin-top: calc(var(--gap) * 3);
    .a {
        color: var(--g6);
        margin-left: calc(var(--gap) * 4);
    }
    .b {
        color: var(--c3);
    }
}
.ml {
    margin-left: 16px;
}
.name {
    max-width: 160px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 16px;
    font-weight: 400;
}
.date {
    font-size: 12px;
    color: #969799;
    margin-top: 2px;
}
</style>